import TimeFilter from 'advanced-filters/components/TimeFilter';
import { pendingFilterSelector } from 'advanced-filters/selectors/filter';
import { modifyPendingFilter } from 'advanced-filters/store/filter';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function BaseTimeFilter() {
  const dispatch = useDispatch();

  const {
    timeFilter,
  } = useSelector(pendingFilterSelector);

  const handleChange = useCallback((args:any) => {
    dispatch(modifyPendingFilter({
      timeFilter: args,
    }));
  }, [dispatch]);

  return (
    <TimeFilter
      timeConfig={timeFilter}
      handleChange={handleChange}
    />
  );
}
